import React, { useState, useEffect } from "react";
import { Icon, TextField } from "ui/components";
import { Channel } from "core/models";
import { cx } from "utils/join-classnames";
import $ from "./StreamInfo.module.scss";

interface Props {
    projectChannels: Channel[];
}

const StreamInfo: React.FC<Props> = ({ projectChannels }) => {
    const [isChannelRtmp, setIsChannelRtmp] = useState<boolean>(false);
    const [rtmpStreamUrl, setRtmpStreamUrl] = useState<string>("");
    const [rtmpStreamKey, setRtmpStreamKey] = useState<string>("");
    const [hlsPullUrl, setHlsPullUrl] = useState<string>("");

    const getChannelStreamDetails = (channel: Channel) => {
        if (channel.mediaEngineStreamKey != null) {
            setIsChannelRtmp(true);
            setRtmpStreamUrl(
                `rtmp://rtmp.spot-on.media/${channel.mediaEngineStreamId}`,
            );
            setRtmpStreamKey(channel.mediaEngineStreamKey);
        } else {
            setIsChannelRtmp(false);
            setHlsPullUrl(channel.exStream.hlsUrl);
        }
    };
    useEffect(() => {
        if (!projectChannels || projectChannels.length === 0) {
            return;
        }
        getChannelStreamDetails(projectChannels[0]);
    }, [projectChannels]);

    return (
        <div className={$.rtmpdetails}>
            <div className={cx($.rtmpheading, $.rtmpheading__light)}>
                <div className={$.rtmpheading__left}>
                    <span className={$.rtmpheading__title}>
                        {isChannelRtmp
                            ? "RTMP Push (RTMP Endpoint)"
                            : "HLS Pull (HLS URL)"}
                    </span>
                </div>
            </div>

            <div>
                <div className={$.streamDetection}>
                    <Icon
                        name="livestream"
                        className={
                            projectChannels &&
                            projectChannels.length > 0 &&
                            projectChannels[0].exStream.online
                                ? $.streamOnline
                                : $.streamOfflinenp
                        }
                    />

                    <p
                        className={cx(
                            $.streamDetectionText,
                            projectChannels &&
                                projectChannels.length > 0 &&
                                projectChannels[0].exStream.online
                                ? $.streamOnline
                                : $.streamOffline,
                        )}
                    >
                        {projectChannels &&
                        projectChannels.length > 0 &&
                        projectChannels[0].exStream.online
                            ? "Incoming stream detected"
                            : "No incoming stream detected"}
                    </p>
                </div>
                {isChannelRtmp && (
                    <>
                        <div className={$.streamDetailsMargins}>
                            <TextField
                                theme="dark"
                                defaultText="RTMP Stream URL"
                                value={rtmpStreamUrl}
                                copiable
                                disabled
                            />
                        </div>

                        <div className={$.streamDetailsMargins}>
                            <TextField
                                theme="dark"
                                defaultText="RTMP Stream Key"
                                value={rtmpStreamKey}
                                copiable
                                disabled
                            />
                        </div>
                    </>
                )}
                {!isChannelRtmp && (
                    <div className={$.streamDetailsMargins}>
                        <TextField
                            theme="dark"
                            defaultText="HLS URL (pull)"
                            value={hlsPullUrl}
                            disabled
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default StreamInfo;
